export default function title (value) {
	// document.title = `${value} | Idicare`
	document.title = `${value} | Smart Care`
}



// WEBPACK FOOTER //
// ./src/utils/title.js